import CONFIG from "./config";

const APP = {
	id: "",
	platform: "web",
	...CONFIG,
};

export default APP;
